import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-cancel">
        <div className="flex justify-center">
          <XCircle size={56} className="text-destructive" strokeWidth={1.4} />
        </div>
        <h1 className="font-display font-semibold text-4xl mt-7">
          Pagamento não concluído
        </h1>
        <p className="text-mute mt-4 leading-relaxed">
          Sem problemas: nada foi cobrado e seu carrinho continua salvo.
          Você pode revisar o pedido quando quiser.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-9">
          <Link
            to="/loja"
            className="inline-flex h-12 items-center rounded-md bg-cyan px-7 font-semibold text-ink transition-all hover:bg-cyan-dark hover:-translate-y-0.5"
            data-testid="payment-cancel-shop"
          >
            Voltar ao catálogo
          </Link>
          <Link
            to="/"
            className="inline-flex h-12 items-center rounded-md border border-white/20 px-7 text-white transition-all hover:border-cyan hover:text-cyan"
            data-testid="payment-cancel-home"
          >
            Início
          </Link>
        </div>
      </div>
    </div>
  );
}
